import _ from 'lodash'
import { useNavigate } from 'react-router-dom'

import UnlockOffers from 'components/UnlockOffers'
import { ANALYTICS_EVENT } from 'constants/index'
import { sendGA4Event } from 'utils/utils'

import AllOffers from './AllOffers'
import ClaimBanner from './ClaimBanner'
import Featured, { selectFeaturedOffers } from './Featured'
import InProgress from './InProgress'

import './index.css'

const EmptyState = ({ offersInProgress, experiment }) => {
  const navigate = useNavigate()

  const checkQuests = () => {
    // `source` tells this way into Quests apart from the tab bar.
    sendGA4Event(ANALYTICS_EVENT.NO_OFFERS_CHECK_QUESTS, {
      source: 'games_empty_state',
      offers_in_progress: offersInProgress,
      ...experiment,
    })
    navigate('/quests')
  }

  return (
    <div className="gamesRedesignEmpty">
      <img className="gamesRedesignEmptyPig" src="/images/pig.png" alt="" width={64} height={64} />
      <h2 className="gamesRedesignEmptyTitle">Piggy is building new offers!</h2>
      <p className="gamesRedesignEmptyText">
        Hard hat on, hammer out... Fresh games are on the way!
      </p>
      <button
        type="button"
        className="gamesRedesignClaimAll gamesRedesignEmptyQuests"
        onClick={checkQuests}
      >
        <span className="gamesRedesignClaimAllLabel">Meanwhile, Check My Quest</span>
      </button>
    </div>
  )
}

/**
 * The redesigned /games page: Featured, All offers and, in a bar above the tabs, the offers
 * already in progress.
 *
 * `variant` is the GAMES_PAGE_REDESIGN group, which picks how the Featured cards look at their
 * minimum size. `experiment` is attached to the analytics of every section.
 */
const GamesRedesign = ({ offers, observer, variant, experiment }) => {
  const activatedOffers = offers?.activatedRow || []
  const featuredRow = offers?.featuredRow || []
  const featuredOffers = selectFeaturedOffers(featuredRow)
  // Genre rows repeat an offer once per category; list it only once.
  const allOffers = _.uniqBy(
    (offers?.genresRows || []).flatMap((row) => row.offers || []),
    'id'
  )

  // Offers already in progress don't count: their bar shows over the empty page.
  const isEmpty = !featuredRow.length && !allOffers.length

  return (
    <div className={`gamesRedesign ${isEmpty ? 'empty' : ''}`}>
      <div className="gamesRedesignTopBanners">
        <ClaimBanner experiment={experiment} />
      </div>
      {isEmpty ? (
        <EmptyState offersInProgress={activatedOffers.length} experiment={experiment} />
      ) : (
        <>
          <Featured
            offers={featuredOffers}
            observer={observer}
            variant={variant}
            experiment={experiment}
          />
          <div className="gamesRedesignSheet">
            <AllOffers offers={allOffers} observer={observer} experiment={experiment} />
            <UnlockOffers />
          </div>
        </>
      )}
      <InProgress offers={activatedOffers} observer={observer} experiment={experiment} />
    </div>
  )
}

export default GamesRedesign
